import { PublicListingStatus } from "../types/PublicListing";

export function mapPublicListingStatusToText(
  status: PublicListingStatus,
): string {
  return status === "public"
    ? "Public"
    : status === "in-preview"
      ? "In Preview"
      : "Not Active";
}
